"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scenePreview = scenePreview;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../utils/");
var _constants = require("../../constants/");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param {{}} scene
 */
function scenePreview(scene) {
  return _objectSpread(_objectSpread({}, scene), {}, {
    title: "".concat(scene.title, " preview"),
    layers: scene.layers.map(function (layerSource) {
      if ([_constants.IMAGE_FILE, _constants.AUDIO_PRESENTER, _constants.BANNER].includes(layerSource.source.type) || layerSource.source.value === _utils.UNASSIGNED) {
        return layerSource;
      }
      if (layerSource.source.thumbnail && layerSource.source.thumbnail !== _utils.EMPTY_THUMBNAIL) {
        return _objectSpread(_objectSpread({}, layerSource), {}, {
          source: {
            type: _constants.IMAGE_FILE,
            value: layerSource.source.thumbnail,
            _id: "".concat(layerSource.source._id, "_thumbnail")
          }
        });
      }
      return _objectSpread(_objectSpread({}, layerSource), {}, {
        source: _objectSpread(_objectSpread({}, layerSource.source), {}, {
          value: _utils.UNASSIGNED
        })
      });
    })
  });
}